import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: "mobileFormatPipe" })
export class MobileFormatPipe implements PipeTransform {
  transform(value: string, isMobile: boolean = true): string {
    if (!value) return "";
    if (isMobile) return value.replace(/(\d{2})(\d{5})(\d{4})/g, "($1) $2-$3");    
    return value.replace(/(\d{2})(\d{4})(\d{4})/g, "($1) $2-$3");
  }
}
